import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import { selectFirebaseAuth } from 'reducers/firebase';

export function PrivateRoute({ auth, ...props }) {
  if (!auth) {
    const baseUrl = window.location.host;
    window.location.replace(baseUrl);
    return null;
  }
  return <Route {...props} />;
}

PrivateRoute.propTypes = {
  auth: PropTypes.shape({
    uid: PropTypes.string,
    token: PropTypes.string,
  }),
};

export default connect(state => ({ auth: selectFirebaseAuth(state) }))(
  PrivateRoute
);
